import { HStack, Menu, MenuList, Text, VStack } from '@chakra-ui/react'
import { Token, Width } from 'types/chakra'
import { IDropdown } from 'types/common/select'
import { getValidArray } from 'utils/common'
import DropdownButton from './DropdownButton'
import DropdownSelection from './DropdownSelection'

interface IDropdownProps {
  options: IDropdown[]
  name: string
  item?: IDropdown
  setValue: (name: string, value: IDropdown) => void
  width?: Token<Width | number, 'sizes'>
  height?: Token<Width | number, 'sizes'>
  maxWidth?: Token<Width | number, 'sizes'>
  text?: string
  isMatchWidth?: boolean
  isDisabled?: boolean
  fontSize?: string
  titleButton?: string
  titleDropdown?: string
  optionHeight?: Token<Width | number, 'sizes'>
}

const Dropdown = (props: IDropdownProps) => {
  const {
    options,
    name,
    setValue,
    item,
    width,
    maxWidth,
    text,
    isMatchWidth,
    height,
    optionHeight,
    isDisabled,
    fontSize,
    titleButton,
    titleDropdown
  } = props
  return (
    <Menu closeOnSelect={true} autoSelect={false} computePositionOnMount matchWidth={isMatchWidth}>
      {({ isOpen }) => (
        <>
          <DropdownButton
            item={item}
            placeHolder={text}
            isOpen={isOpen}
            width={width}
            height={height}
            fontSize={fontSize}
            isDisabled={isDisabled}
            titleButton={titleButton}
          />
          <MenuList zIndex="10001" maxWidth={maxWidth} minWidth="auto" border="1px solid #E2E8F0">
            {titleDropdown && (
              <Text fontSize="xs" paddingX={4} paddingY={1} color="gray.400">
                {titleDropdown}
              </Text>
            )}
            {getValidArray(options).map((option: IDropdown, index: number) => (
              <DropdownSelection
                key={`${name}-${index}`}
                onClick={() => setValue(name, option)}
                label={
                  option.description ? (
                    <VStack justifyContent="flex-start" alignItems="flex-start" spacing={0}>
                      <Text fontSize="18px" color="gray.800" >
                        {option.title}
                      </Text>
                      <Text fontSize="14px" color="gray.500" >
                        {option.description}
                      </Text>
                    </VStack>
                  ) : (
                    <Text noOfLines={2}>{option.title}</Text>
                  )
                }
                isSelected={option.value === item?.value}
                width={width}
                maxWidth={maxWidth}
                height={optionHeight}
                fontSize={fontSize}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  )
}

export default Dropdown
